import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Enregistrement des éléments Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const Dashboard = () => {
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    let isMounted = true;

    // Récupération des données
    axios.get('http://localhost:5000/api/products/products')
      .then((res) => isMounted && setProducts(res.data.products || []))
      .catch((err) => console.error('Erreur Produits:', err));

    axios.get('http://localhost:5000/api/auth/users')
      .then((res) => isMounted && setUsers(res.data.users || []))
      .catch((err) => console.error('Erreur Utilisateurs:', err));

    axios.get('http://localhost:5000/api/orders/orders')
      .then((res) => isMounted && setOrders(res.data.orders || []))
      .catch((err) => console.error('Erreur Commandes:', err));

    axios.get('http://localhost:5000/api/orders/payments')
      .then((res) => isMounted && setPayments(res.data.payments || []))
      .catch((err) => console.error('Erreur Paiements:', err));

    return () => {
      isMounted = false; // Empêche les mises à jour après démontage
    };
  }, []);

  // Traitement des données pour les graphiques
  const productCategories = useMemo(() => {
    return Array.isArray(products)
      ? products.reduce((acc, product) => {
          acc[product.category] = (acc[product.category] || 0) + 1;
          return acc;
        }, {})
      : {};
  }, [products]);

  const paymentMethods = useMemo(() => {
    return Array.isArray(payments)
      ? payments.reduce((acc, payment) => {
          acc[payment.method] = (acc[payment.method] || 0) + 1;
          return acc;
        }, {})
      : {};
  }, [payments]);

  const categoryChart = {
    labels: Object.keys(productCategories),
    datasets: [
      {
        label: 'Produits par Catégorie',
        data: Object.values(productCategories),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
      },
    ],
  };

  const paymentChart = {
    labels: Object.keys(paymentMethods),
    datasets: [
      {
        label: 'Méthodes de Paiement',
        data: Object.values(paymentMethods),
        backgroundColor: ['#FF9F40', '#FFCD56', '#4BC0C0'],
      },
    ],
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Tableau de Bord
      </Typography>
      <Grid container spacing={3}>
        {/* Section Produits */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Produits par Catégorie</Typography>
              <Pie data={categoryChart} />
            </CardContent>
          </Card>
        </Grid>

        {/* Section Méthodes de Paiement */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Répartition des Méthodes de Paiement</Typography>
              <Pie data={paymentChart} />
            </CardContent>
          </Card>
        </Grid>

        {/* Section Utilisateurs */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Utilisateurs</Typography>
              <Typography variant="body1">Total utilisateurs : {users.length}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Section Commandes */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Commandes</Typography>
              <Typography variant="body1">Total commandes : {orders.length}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
